import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  Box,
} from '@mui/material';
import { usePdfStore } from '../../../store/hooks';

export const PdfLoadingDialog: React.FC = observer(() => {
  const pdfStore = usePdfStore();

  return (
    <Dialog
      open={pdfStore.isOpen}
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason === 'backdropClick') return;
      }}
    >
      <DialogTitle>Generowanie PDF...</DialogTitle>
      <DialogContent>
        <Box sx={{ width: '100%', minWidth: 300, mt: 1 }}>
          <LinearProgress variant="determinate" value={pdfStore.progress} />
        </Box>
        <DialogContentText sx={{ mt: 2 }}>
          {pdfStore.progressLabel}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
});
